import { GetterTree, MutationTree } from "vuex";
import { LocalPlansType, PlansStoreType } from "@/types/PlansType";

const state: PlansStoreType = {
  localPlanSelected: {} as LocalPlansType,
};

const getters: GetterTree<PlansStoreType, any> = {
  getLocalPlanSelected: (state) => state.localPlanSelected,
};

const mutations: MutationTree<PlansStoreType> = {
  setLocalPlanSelected(state, payload: LocalPlansType) {
    state.localPlanSelected = payload;
  },
};

export default {
  state,
  getters,
  mutations,
};
